import { formatDistanceToNowStrict } from 'date-fns';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import getIsDeviceSetupNeeded from '../../../utils/getIsDeviceSetupNeeded';
import getMemberUrl from '../../../utils/getMemberUrl';
import { useOrganizationMemberDetailsContext } from '../../context/OrganizationMemberDetailsContext';
import DeviceStatus from '../../DeviceInfo/DeviceStatus';
import * as Style from './style.module.scss';
import SelectableText from '../../../../../components/SelectableText';

const MemberDeviceInfo: React.FC = () => {
    const navigate = useNavigate();
    const { memberDetails } = useOrganizationMemberDetailsContext();
    const { member_info } = memberDetails;
    const { currentDevice } = useOrganizationMemberDetailsContext();
    const isDeviceOnline = !!currentDevice?.online_status?.is_online;
    const lastOnline = currentDevice?.online_status?.last_online || undefined;
    const deviceSerial = currentDevice?.device_serial || 'N/A';
    const deviceStatus = currentDevice?.device_status || null;
    // HWM-23225: while a discharge is processing the device is pending return, so its
    // connectivity state is stale. Keep the Device ID and the History Log link, drop the status.
    // Finalized discharges don't render this pill at all — see MemberDetailsWrapper's Header.
    const isDischarged = !!member_info.status_info?.discharged_at;

    const handleClick = () => {
        navigate(getMemberUrl(member_info.hero_user_id, member_info.member_id, 'log'));
    };

    const isDeviceSetupNeeded = React.useMemo(() => {
        return getIsDeviceSetupNeeded(deviceStatus);
    }, [deviceStatus]);

    const lastOnlineDistance = lastOnline
        ? formatDistanceToNowStrict(new Date(lastOnline))
        : undefined;

    return (
        <>
            <ClickableOpacity alt="device-info" onClick={handleClick}>
                <div className={Style.wrapper}>
                    <DeviceStatus
                        isDeviceOnline={isDeviceOnline}
                        isDeviceSetupNeeded={isDeviceSetupNeeded}
                        deviceStatus={deviceStatus}
                        showStatusSignifier={!isDischarged}
                    />

                    <div className={Style.text}>
                        <SelectableText>
                            <strong>{deviceSerial}</strong>
                        </SelectableText>

                        {isDischarged ? null : isDeviceOnline ? (
                            <strong className={Style.online}>Online</strong>
                        ) : currentDevice?.device_status === 'ORDERED' ? (
                            <strong>Ordered</strong>
                        ) : isDeviceSetupNeeded ? (
                            <strong className={Style.alert}>Setup Needed</strong>
                        ) : (
                            <strong className={Style.alert}>Offline {lastOnlineDistance}</strong>
                        )}
                    </div>
                </div>
            </ClickableOpacity>
        </>
    );
};

export default MemberDeviceInfo;
